import { createRoute, Navigate, Outlet } from "@tanstack/react-router";
import LeadDetailsPage from "pages/app/LeadDetailsPage";
import { LeadsPage } from "pages/app/LeadsPage";

import LeadBuyerActivityPage from "components/leads/lead_details/LeadBuyerActivityPage";
import { useUnifiedContacts } from "lib/hooks/useUnifiedContacts";
import { rootRoute } from "../rootRoute";

export const leadsLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/leads",
  staticData: { pageName: "", breadcrumbLabel: "Leads" },
  component: Outlet,
});

export const leadsIndexRoute = createRoute({
  getParentRoute: () => leadsLayoutRoute,
  path: "/",
  staticData: { pageName: "Leads" },
  component: LeadsPage,
});

export const leadIdLayoutRoute = createRoute({
  getParentRoute: () => leadsLayoutRoute,
  path: "/$id",
  staticData: { pageName: "" },
  component: Outlet,
});

export const leadDetailRoute = createRoute({
  getParentRoute: () => leadIdLayoutRoute,
  path: "/",
  staticData: { pageName: "Lead" },
  component: function LeadDetailRouteComp() {
    const { id } = leadDetailRoute.useParams();
    return <LeadDetailsPage id={id} />;
  },
});

export const leadBuyerActivityRoute = createRoute({
  getParentRoute: () => leadIdLayoutRoute,
  path: "/buyer-activity",
  staticData: { pageName: "Lead buyer activity" },
  component: function LeadBuyerActivityRouteComp() {
    const { id } = leadBuyerActivityRoute.useParams();
    const isUnifiedContactsEnabled = useUnifiedContacts();
    if (!isUnifiedContactsEnabled) {
      return <Navigate to={leadDetailRoute.to} params={{ id }} replace />;
    }
    return <LeadBuyerActivityPage leadId={id} />;
  },
});

export const leadsRouteTree = leadsLayoutRoute.addChildren([
  leadsIndexRoute,
  leadIdLayoutRoute.addChildren([leadDetailRoute, leadBuyerActivityRoute]),
]);
